import { CarLightDimmedIcon } from './CarLightDimmedIcon';

/**
 * author: Michael Irigoyen
 * id DA708BEF-4826-49CF-8872-C42996C9616F
 * name car-light-dimmed
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-light-dimmed.svg
 * tags
 * - Automotive 
 */
export const LowBeamIcon = CarLightDimmedIcon;
export default LowBeamIcon